import { Chip, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DEFAULT_LOCALE, normalizeLocale, SUPPORTED_LOCALES } from '@/i18n/constants';

const CHIP_LABEL: Record<(typeof SUPPORTED_LOCALES)[number], string> = {
  en: 'EN',
  es: 'ES',
  fr: 'FR',
  pt: 'PT',
};

/**
 * Four locale chips; the choice persists locally (see i18n.ts `languageChanged`). `onChange`
 * lets a caller also save it elsewhere (the Account screen's `PATCH /api/account/locale`).
 */
export function LanguageChips({ onChange }: { onChange?: (code: string) => void } = {}) {
  const { t, i18n } = useTranslation();
  const current = normalizeLocale(i18n.resolvedLanguage ?? i18n.language) ?? DEFAULT_LOCALE;

  return (
    <Stack direction="row" spacing={0.5} component="span">
      {SUPPORTED_LOCALES.map((code) => {
        const selected = code === current;
        const label = t(`language.${code}`);
        return (
          <Chip
            key={code}
            label={CHIP_LABEL[code]}
            size="small"
            variant={selected ? 'filled' : 'outlined'}
            lang={code}
            aria-pressed={selected}
            aria-label={label}
            title={label}
            onClick={() => {
              void i18n.changeLanguage(code);
              onChange?.(code);
            }}
          />
        );
      })}
    </Stack>
  );
}
